import getCharts from '../getCharts'
import { SaveRisks } from '../../constants/api.config'

export default async function SaveRisksData(mode, name, aliasName, keywords, diagnoseID, riskFactors) {
  try {
    const payload = { mode, name, aliasName, keywords, diagnoseID, riskFactors }
    const res = await getCharts(SaveRisks, payload)
    return res.data
  } catch (error) {
    return error
  }
}
